import { Select } from "@tfg/ui"
import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"
import { removeUndefined } from "@tfg/types/schemas/utils"

import { useFindProductCollectionValues } from "~/gen/api"

interface Props {
  filtersValue: filtersValidationType
  setFiltersValue: Dispatch<SetStateAction<filtersValidationType>>
}

export const ProductCollectionFilter = ({
  setFiltersValue,
  filtersValue,
  ...props
}: Props) => {
  const { t } = useTranslation("products")
  const { data: productCollectionValues, isLoading } =
    useFindProductCollectionValues({
      ...removeUndefined(filtersValue),
    })

  return (
    <Select
      // defaults
      w={150}
      clearable
      searchable
      isLoading={isLoading}
      // overrides
      {...props}
      // managed
      data={productCollectionValues?.data.map((collection) => ({
        value: collection,
        label: collection,
      }))}
      value={filtersValue.collection ?? null}
      onChange={(value) =>
        setFiltersValue({ ...filtersValue, collection: value ?? undefined })
      }
      placeholder={t("lists.placeholders.collection")}
    />
  )
}
